/* EVA — Egypt Retreat · Vocal Activation — shared behaviours */
(function () {
  'use strict';
  if (window.__evaInit) return;
  window.__evaInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  var revealIO = null;
  function bindReveals(scope) {
    var els = scope.querySelectorAll('.eva-reveal:not([data-eva-bound])');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eva-in'); el.setAttribute('data-eva-bound', '1'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('eva-in');
            revealIO.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) {
      el.setAttribute('data-eva-bound', '1');
      revealIO.observe(el);
    });
  }

  /* ---------- stagger children ---------- */
  function bindStagger(scope) {
    scope.querySelectorAll('[data-eva-stagger]:not([data-eva-bound])').forEach(function (parent) {
      parent.setAttribute('data-eva-bound', '1');
      var step = parseInt(parent.getAttribute('data-eva-stagger'), 10) || 90;
      Array.prototype.forEach.call(parent.children, function (child, i) {
        child.style.setProperty('--eva-d', (i * step) + 'ms');
      });
    });
  }

  /* ---------- parallax ---------- */
  var parallaxEls = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var rect = el.parentElement.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var speed = parseFloat(el.getAttribute('data-eva-parallax')) || 0.14;
        var offset = (rect.top + rect.height / 2 - vh / 2) * speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      updateTimelines(vh);
    });
  }
  function bindParallax(scope) {
    if (reduced) return;
    scope.querySelectorAll('[data-eva-parallax]:not([data-eva-bound])').forEach(function (el) {
      el.setAttribute('data-eva-bound', '1');
      parallaxEls.push(el);
    });
  }

  /* ---------- timeline progress ---------- */
  var timelines = [];
  function bindTimelines(scope) {
    scope.querySelectorAll('.eva-tl:not([data-eva-bound])').forEach(function (el) {
      el.setAttribute('data-eva-bound', '1');
      timelines.push(el);
    });
  }
  function updateTimelines(vh) {
    timelines.forEach(function (tl) {
      var rect = tl.getBoundingClientRect();
      var progress = (vh * 0.72 - rect.top) / rect.height;
      progress = Math.max(0, Math.min(1, progress));
      tl.style.setProperty('--eva-tlp', reduced ? 1 : progress.toFixed(3));
    });
  }

  /* ---------- FAQ accordion ---------- */
  function bindFaq(scope) {
    scope.querySelectorAll('.eva-faq__q:not([data-eva-bound])').forEach(function (btn) {
      btn.setAttribute('data-eva-bound', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('.eva-faq__item');
        var open = item.classList.toggle('eva-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- ambient video cover sizing ---------- */
  function sizeAmbient() {
    document.querySelectorAll('[data-eva-video]').forEach(function (wrap) {
      var inner = wrap.firstElementChild;
      if (!inner) return;
      var scale = Math.max(wrap.offsetWidth / 16, wrap.offsetHeight / 9);
      inner.style.width = Math.ceil(scale * 16) + 'px';
      inner.style.height = Math.ceil(scale * 9) + 'px';
    });
  }

  /* ---------- hero immersive mode (sound on = text away) ---------- */
  function wistiaCall(id, fn) {
    window._wq = window._wq || [];
    window._wq.push({ id: id, onReady: fn });
  }

  function bindHeroSound(scope) {
    if (reduced) {
      scope.querySelectorAll('[data-eva-video], .eva-hero__sound, [data-eva-dock]').forEach(function (el) { el.remove(); });
      return;
    }
    scope.querySelectorAll('.eva-hero__sound[data-eva-sound]:not([data-eva-bound])').forEach(function (btn) {
      btn.setAttribute('data-eva-bound', '1');
      var hero = btn.closest('.eva-hero');
      var id = btn.getAttribute('data-eva-sound');
      var dock = hero ? hero.querySelector('[data-eva-dock]') : null;
      var learn = dock ? dock.querySelector('[data-eva-learn]') : null;
      var exitBtn = dock ? dock.querySelector('[data-eva-exit]') : null;
      var live = false;

      wistiaCall(id, function (video) { video.mute(); video.play(); });

      function enter() {
        if (live || !dock || !learn) return;
        live = true;
        /* unmute the raw element synchronously — mobile browsers only honour
           unmute inside the tap gesture, not in Wistia's async queue */
        var rawVideo = hero.querySelector('.eva-hero__video video');
        if (rawVideo) {
          rawVideo.muted = false;
          rawVideo.volume = 1;
          var played = rawVideo.play();
          if (played && played.catch) played.catch(function () {});
        }
        wistiaCall(id, function (video) {
          video.unmute();
          video.volume(1);
          if (video.state() !== 'playing') video.play();
        });
        var from = btn.getBoundingClientRect();
        hero.classList.add('eva-hero--live');
        dock.hidden = false;
        var to = learn.getBoundingClientRect();
        var dx = (from.left + from.width / 2) - (to.left + to.width / 2);
        var dy = (from.top + from.height / 2) - (to.top + to.height / 2);
        learn.animate([
          { transform: 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)', opacity: 0.3 },
          { transform: 'translate(0,0)', opacity: 1 }
        ], { duration: 950, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
        if (exitBtn) {
          exitBtn.animate([
            { opacity: 0, transform: 'translateY(12px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 500, delay: 620, fill: 'backwards', easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
        }
      }

      function leave() {
        if (!live || !dock) return;
        live = false;
        var rawVideo = hero.querySelector('.eva-hero__video video');
        if (rawVideo) rawVideo.muted = true;
        wistiaCall(id, function (video) { video.mute(); });
        hero.classList.remove('eva-hero--live');
        var anim = dock.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 450, easing: 'ease-out' });
        anim.onfinish = function () { if (!live) dock.hidden = true; };
      }

      btn.addEventListener('click', enter);
      if (exitBtn) exitBtn.addEventListener('click', leave);
      if (learn) {
        learn.addEventListener('click', function () {
          var sel = learn.getAttribute('data-eva-learn-target') || '';
          var target = sel ? document.querySelector(sel) : null;
          if (target) target.scrollIntoView({ behavior: 'smooth' });
        });
      }

      if (hero && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && live) leave();
          });
        }, { threshold: 0.1 }).observe(hero);
      }
    });
  }

  /* ---------- gallery drag-to-scroll ---------- */
  function bindGallery(scope) {
    scope.querySelectorAll('.eva-gal:not([data-eva-bound])').forEach(function (gal) {
      gal.setAttribute('data-eva-bound', '1');
      var down = false, startX = 0, startLeft = 0;
      gal.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; startX = e.clientX; startLeft = gal.scrollLeft;
        gal.classList.add('eva-dragging');
        gal.setPointerCapture(e.pointerId);
      });
      gal.addEventListener('pointermove', function (e) {
        if (!down) return;
        gal.scrollLeft = startLeft - (e.clientX - startX);
      });
      ['pointerup', 'pointercancel'].forEach(function (evt) {
        gal.addEventListener(evt, function () {
          down = false;
          gal.classList.remove('eva-dragging');
        });
      });
    });
  }

  /* ---------- init ---------- */
  function init(scope) {
    scope = scope || document;
    bindStagger(scope);
    bindReveals(scope);
    bindParallax(scope);
    bindTimelines(scope);
    bindFaq(scope);
    bindGallery(scope);
    bindHeroSound(scope);
    sizeAmbient();
    setTimeout(sizeAmbient, 800);
    setTimeout(sizeAmbient, 2500);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { sizeAmbient(); onScroll(); }, { passive: true });

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
